export default __webpack_public_path__ + "static/pregunta-2-98f91a8de885c663398c50a149cba4a8.png";